export enum ClosedLoopEntityType {
    
     DashConfirmation = 0,
     FollowUpConfirmation = 1,
     DonorShieldConfirmation = 2,
     NkrDonorConfirmation = 3,
     MicrositeConfirmation = 4,
     ManualConfirmation = 5,
     NkrRecipientConfirmation = 6
}